import { IconStorage } from "@app/shared/icons/interfaces";

export const filterLines: IconStorage = {
  svgCode: () => ([
    "M6 12H18M3 6H21M9 18H15",
  ]),
};
